import { render, staticRenderFns } from "./discriMix.vue?vue&type=template&id=520b2584"
import script from "./discriMix.vue?vue&type=script&lang=js"
export * from "./discriMix.vue?vue&type=script&lang=js"
import style0 from "./discriMix.vue?vue&type=style&index=0&id=520b2584&prod&lang=scss&scope=true"
import style1 from "./discriMix.vue?vue&type=style&index=1&id=520b2584&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports